module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("ALSO BY ROBERT GOLDSBOROUGH ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('u', [_vm._v("The Nero Wolfe\n\t\t\t\t\tMysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Murder in E Minor")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Death\n\t\t\t\t\t\ton Deadline")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Fade\n\t\t\t\t\t\tto Black")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("The\n\t\t\t\t\t\tBloodied Ivy")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("The\n\t\t\t\t\t\tLast Coincidence")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Silver Spire")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("The\n\t\t\t\t\t\tMissing Chapter")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Archie Meets Nero Wolfe")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Murder in the Ball Park")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Archie in the Crosshairs")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Stop\n\t\t\t\t\t\tthe Presses!")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Murder, Stage Left")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("The\n\t\t\t\t\t\tBattered Badge")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Death\n\t\t\t\t\t\tof an Art Collector")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Archie Goes Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Trouble at the Brownstone")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('u', [_vm._v("The Snap Malek\n\t\t\t\t\tMysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Three\n\t\t\t\t\t\tStrikes You’re Dead")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Shadow of the Bomb")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("A\n\t\t\t\t\t\tDeath in Pilsen")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("A\n\t\t\t\t\t\tPresident in Peril")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Terror at the Fair")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent- ParaOverride-9",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "ORIM-ital"
  }, [_c('i', [_vm._v("Stairway to Nowhere & Other Stories")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a611ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissingHeiress.vue
// module id = 66
// module chunks = 0